var _rect, _path, _path2, _path3, _rect2, _rect3, _path4, _line, _line2, _line3, _line4, _line5, _line6, _circle, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeaImages2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 236,
    height: 484,
    viewBox: "0 0 236 484",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.4668,
    y: 2.88965,
    width: 229.295,
    height: 478.463,
    rx: 27.5,
    stroke: "#C6C6C6",
    strokeWidth: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.384 14.5039H184.795C184.47 14.5039 184.206 14.7677 184.206 15.0931V20.1996C184.206 20.525 184.47 20.7888 184.795 20.7888H185.384C185.71 20.7888 185.974 20.525 185.974 20.1996V15.0931C185.974 14.7677 185.71 14.5039 185.384 14.5039ZM182.047 15.8787H182.636C182.962 15.8787 183.226 16.1425 183.226 16.4679V20.1995C183.226 20.525 182.962 20.7888 182.636 20.7888H182.047C181.722 20.7888 181.458 20.525 181.458 20.1995V16.4679C181.458 16.1425 181.722 15.8787 182.047 15.8787ZM179.886 17.2537H179.297C178.972 17.2537 178.708 17.5175 178.708 17.8429V20.1997C178.708 20.5251 178.972 20.7889 179.297 20.7889H179.886C180.212 20.7889 180.476 20.5251 180.476 20.1997V17.8429C180.476 17.5175 180.212 17.2537 179.886 17.2537ZM177.137 18.432H176.548C176.223 18.432 175.959 18.6958 175.959 19.0212V20.1996C175.959 20.5251 176.223 20.7889 176.548 20.7889H177.137C177.463 20.7889 177.727 20.5251 177.727 20.1996V19.0212C177.727 18.6958 177.463 18.432 177.137 18.432Z",
    fill: "#333E63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.437 15.7518C194.748 15.7519 196.009 16.2551 196.959 17.1575C197.031 17.2272 197.145 17.2263 197.215 17.1556L197.899 16.466C197.935 16.4301 197.955 16.3815 197.954 16.3309C197.954 16.2803 197.934 16.2319 197.898 16.1965C195.404 13.8089 191.47 13.8089 188.977 16.1965C188.941 16.2319 188.92 16.2803 188.92 16.3309C188.92 16.3815 188.939 16.4301 188.975 16.466L189.659 17.1556C189.73 17.2264 189.844 17.2273 189.915 17.1575C190.866 16.2551 192.126 15.7518 193.437 15.7518ZM194.748 19.6407C194.785 19.6049 194.805 19.5556 194.804 19.5045C194.803 19.4533 194.781 19.4049 194.743 19.3706C193.988 18.7329 192.883 18.7329 192.129 19.3706C192.091 19.4049 192.069 19.4533 192.067 19.5044C192.066 19.5556 192.086 19.6049 192.123 19.6407L193.305 20.8321C193.339 20.8671 193.387 20.8868 193.436 20.8868C193.485 20.8868 193.532 20.8671 193.567 20.8321L194.748 19.6407ZM195.387 18.7455C194.853 18.2625 194.158 17.995 193.438 17.9951C192.718 17.9954 192.024 18.2628 191.491 18.7455C191.419 18.8141 191.305 18.8126 191.235 18.7422L190.552 18.0526C190.516 18.0165 190.496 17.9674 190.496 17.9164C190.497 17.8654 190.518 17.8167 190.554 17.7813C192.18 16.2703 194.698 16.2703 196.323 17.7813C196.36 17.8167 196.381 17.8654 196.382 17.9164C196.382 17.9674 196.362 18.0164 196.326 18.0526L195.643 18.7422C195.573 18.8126 195.459 18.8141 195.387 18.7455Z",
    fill: "#333E63"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M214.453 16.7627V19.1195C214.927 18.9199 215.236 18.4556 215.236 17.9411C215.236 17.4267 214.927 16.9623 214.453 16.7627Z",
    fill: "#333E63"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.35,
    x: 201.203,
    y: 14.9058,
    width: 11.9627,
    height: 5.48133,
    rx: 2.16667,
    stroke: "#C6C6C6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 201.879,
    y: 15.5845,
    width: 10.6058,
    height: 4.12448,
    rx: 1.33333,
    fill: "#333E63"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7101 18.2617C30.2733 18.7236 29.763 18.9546 29.1794 18.9546C28.4919 18.9546 27.944 18.7147 27.5358 18.2349C27.1276 17.7515 26.9235 17.1177 26.9235 16.3335C26.9235 15.8179 27.0273 15.3506 27.235 14.9316C27.4427 14.5127 27.7381 14.1868 28.1213 13.9541C28.5044 13.7214 28.9484 13.605 29.4533 13.605C30.241 13.605 30.8659 13.8986 31.3278 14.4858C31.7897 15.0731 32.0207 15.859 32.0207 16.8438V17.209C32.0207 18.6198 31.702 19.6958 31.0646 20.437C30.4272 21.1782 29.4766 21.5542 28.2126 21.5649H28.0568V20.4854H28.2448C29.0146 20.4746 29.6055 20.2902 30.0173 19.9321C30.429 19.5705 30.66 19.0137 30.7101 18.2617ZM29.4533 17.9341C29.7147 17.9341 29.96 17.8589 30.1891 17.7085C30.4183 17.5581 30.5955 17.3504 30.7209 17.0854V16.5752C30.7209 15.9987 30.6027 15.535 30.3664 15.1841C30.13 14.8332 29.8239 14.6577 29.4479 14.6577C29.0719 14.6577 28.7712 14.8135 28.5456 15.125C28.3236 15.4329 28.2126 15.8232 28.2126 16.2959C28.2126 16.7865 28.3254 17.1821 28.5509 17.4829C28.7765 17.7837 29.0773 17.9341 29.4533 17.9341ZM33.8915 20.1577C34.135 20.1577 34.323 20.2275 34.4555 20.3672C34.588 20.5033 34.6542 20.6751 34.6542 20.8828C34.6542 21.0869 34.588 21.257 34.4555 21.3931C34.323 21.5256 34.135 21.5918 33.8915 21.5918C33.6588 21.5918 33.4744 21.5256 33.3383 21.3931C33.2022 21.2606 33.1342 21.0905 33.1342 20.8828C33.1342 20.6751 33.2004 20.5033 33.3329 20.3672C33.4654 20.2275 33.6516 20.1577 33.8915 20.1577ZM33.8915 15.5977C34.135 15.5977 34.323 15.6675 34.4555 15.8071C34.588 15.9432 34.6542 16.1151 34.6542 16.3228C34.6542 16.5269 34.588 16.6969 34.4555 16.833C34.323 16.9655 34.135 17.0317 33.8915 17.0317C33.6588 17.0317 33.4744 16.9655 33.3383 16.833C33.2022 16.7005 33.1342 16.5304 33.1342 16.3228C33.1342 16.1151 33.2004 15.9432 33.3329 15.8071C33.4654 15.6675 33.6516 15.5977 33.8915 15.5977ZM40.1183 18.7451H41.0905V19.7925H40.1183V21.5327H38.8131V19.7925H35.4347L35.3971 18.9976L38.7702 13.7124H40.1183V18.7451ZM36.7667 18.7451H38.8131V15.4795L38.7165 15.6514L36.7667 18.7451ZM45.2494 21.5327H43.9496V15.2539L42.0321 15.9092V14.8081L45.0829 13.6855H45.2494V21.5327Z",
    fill: "#333E63"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 38.832,
    y1: 451.159,
    x2: 64.9763,
    y2: 451.159,
    stroke: "#C6C6C6",
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 42.543,
    y1: 448.086,
    x2: 61.2654,
    y2: 448.086,
    stroke: "#C6C6C6",
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 171.254,
    y1: 451.159,
    x2: 197.398,
    y2: 451.159,
    stroke: "#C6C6C6",
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 174.965,
    y1: 448.086,
    x2: 193.687,
    y2: 448.086,
    stroke: "#C6C6C6",
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 105.043,
    y1: 451.159,
    x2: 131.187,
    y2: 451.159,
    stroke: "#C6C6C6",
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 108.754,
    y1: 448.086,
    x2: 127.476,
    y2: 448.086,
    stroke: "#C6C6C6",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 118.359,
    cy: 70.3789,
    r: 11,
    fill: "#B0BEC5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 93.5391,
    y: 88.958,
    width: 20,
    height: 20,
    rx: 10,
    stroke: "#9C9C9C",
    strokeWidth: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 122.672,
    y: 88.958,
    width: 20,
    height: 20,
    rx: 10,
    stroke: "#9C9C9C",
    strokeWidth: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 134.115,
    y: 145.958,
    width: 66.6873,
    height: 64.9672,
    rx: 20,
    stroke: "#C6C6C6",
    strokeWidth: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 35.4277,
    y: 145.958,
    width: 66.6873,
    height: 64.9672,
    rx: 20,
    stroke: "#C6C6C6",
    strokeWidth: 2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 134.115,
    y: 242.925,
    width: 66.6873,
    height: 64.9672,
    rx: 20,
    stroke: "#C6C6C6",
    strokeWidth: 2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 35.4277,
    y: 242.925,
    width: 66.6873,
    height: 64.9672,
    rx: 20,
    stroke: "#C6C6C6",
    strokeWidth: 2
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 35.4277,
    y: 334.957,
    width: 165.375,
    height: 72.6288,
    rx: 22,
    stroke: "#C6C6C6",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaImages2);
export default __webpack_public_path__ + "static/media/fea-images2.f1d22ba245b77aaa3950f21f41c9c448.svg";
export { ForwardRef as ReactComponent };